import React from 'react'
import cls from './Pitch.module.css';

export const PitchTabs = () => (<div className={cls.pitchTabs} />)
